import styled from 'styled-components';

export const ChartContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  gap: 32px;
  min-height: 200px;
  width: 100%;

  @media (max-width: ${({ theme }) => theme.breakpoints.Tablet}) {
    flex-direction: column;
    align-items: center;
  }
`;

export const SvgContainer = styled.div`
  flex: 1;
  max-width: 480px;
  position: relative;

  & > svg {
    display: block;
    width: 100%;
    height: auto;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.Tablet}) {
    flex: none;
    width: 240px;
    max-width: 100%;
  }
`;

export const DonutCenter = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
`;

export const DonutCenterValue = styled.span`
  ${({ theme }) => theme.fonts.PoppinsBold};
  font-size: 32px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const DonutCenterLabel = styled.span`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 11px;
  color: ${({ theme }) => theme.colors.Grey6};
`;

export const LegendContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const LegendDot = styled.div<{ $color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ $color }) => $color};
  flex-shrink: 0;
`;

export const LegendLabel = styled.span`
  ${({ theme }) => theme.fonts.PoppinsText};
  font-size: 13px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
`;

export const LegendPercentage = styled.span`
  ${({ theme }) => theme.fonts.PoppinsBold};
  font-size: 13px;
  color: ${({ theme }) => theme.colors.TextDarkGrey};
  margin-left: auto;
`;
